import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from '../../../../../node_module_clones/recompose';
import { connect } from 'react-redux';

// Actions
import { openPopup, closePopup } from '../../../../components/popupPanel/popupActions';

// Effects
import usePrevious from '../../../../utils/react/usePrevious';

// Components
import Icon from '../../../../components/icons/Icon';
import PopupToolButton from '../../../../components/popupPanel/PopupToolButton';
import PopupPanel from '../../../../components/popupPanel/PopupPanel';
import BreadcrumbTruncateUtilPopupContent from './BreadcrumbTruncateUtilPopupContent';

import breadcrumbTruncateUtilDropTarget from './breadcrumbTruncateUtilDropTarget';

import './BreadcrumbTruncateUtil.scss';
import { PopupIds } from '../../../../components/popupPanel/popupConstants';

const POPUP_ID = PopupIds.BREADCRUMB_TRUNCATE_MENU;

const mapDispatchToProps = (dispatch) => ({
    dispatchOpenPopup: () => dispatch(openPopup(POPUP_ID)),
    dispatchClosePopup: () => dispatch(closePopup(POPUP_ID)),
});

const enhance = compose(connect(null, mapDispatchToProps), breadcrumbTruncateUtilDropTarget);

const BreadcrumbTruncateUtil = ({
    breadcrumbPath,
    renderedBreadcrumbs,
    currentBoardId,
    isHovered,
    canDrop,
    connectDropTarget,
    dispatchOpenPopup,
    dispatchClosePopup,
}) => {
    const prevIsHovered = usePrevious(isHovered);

    useEffect(() => {
        if (isHovered && !prevIsHovered) {
            dispatchOpenPopup();
        }
    }, [isHovered, prevIsHovered]);

    return (
        <div
            ref={connectDropTarget}
            className={classNames('BreadcrumbTruncateUtil', { hovered: isHovered, 'can-drop': canDrop })}
        >
            <PopupToolButton popupId={POPUP_ID} icon={<Icon name="menu-ellipsis" />} />
            <PopupPanel popupId={POPUP_ID} className="BreadcrumbTruncatePopupPanel" closeOnPointerUp>
                <BreadcrumbTruncateUtilPopupContent
                    breadcrumbPath={breadcrumbPath}
                    renderedBreadcrumbs={renderedBreadcrumbs}
                    currentBoardId={currentBoardId}
                    dispatchClosePopup={dispatchClosePopup}
                />
            </PopupPanel>
        </div>
    );
};

BreadcrumbTruncateUtil.propTypes = {
    currentBoardId: PropTypes.string,
    isHovered: PropTypes.bool,
    canDrop: PropTypes.bool,
    breadcrumbPath: PropTypes.array,
    renderedBreadcrumbs: PropTypes.array,
    connectDropTarget: PropTypes.func,
    dispatchOpenPopup: PropTypes.func,
    dispatchClosePopup: PropTypes.func,
};

export default enhance(BreadcrumbTruncateUtil);
